// Separate PNGs keep this script small. Asset URLs can be replaced with Shopify Files links.
(() => {
  const base = document.currentScript.src;
  const files = {surf:'mm-art-surf.png',alpine:'mm-art-alpine.png',dinosaur:'mm-art-dinosaur.png',unicorn:'mm-art-unicorn.png',truck:'mm-art-truck.png'};
  window.MIMExampleArt = Object.fromEntries(Object.entries(files).map(([id,path])=>[id,new URL(path,base).href]));
  const pending = new Map();
  async function load(id){
    if(!pending.has(id))pending.set(id,(async()=>{
      const response=await fetch(window.MIMExampleArt[id]);
      if(!response.ok)throw Error('Sticker artwork could not load. Please reload before exporting.');
      const blob=await response.blob();
      if(!blob.type.startsWith('image/'))throw Error('Sticker image is unavailable.');
      const data=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=reject;reader.readAsDataURL(blob)});
      window.MIMExampleArt[id]=data;
    })().catch(error=>{pending.delete(id);throw error}));
    return pending.get(id);
  }
  window.MIMEnsureArt=async items=>Promise.all([...new Set(items.filter(o=>o.type==='image').map(o=>o.assetId))].map(load));
  const generate=window.MIMExport.generate;
  window.MIMExport.generate=async (payload,makeNode)=>{
    await window.MIMEnsureArt(payload.sides.filter(s=>payload.printSides.includes(s.index)).flatMap(s=>s.items));
    return generate(payload,makeNode);
  };
})();
